export default function ActiveFiltersContainer({
  hasActiveFilters,
  children,
  handleClearFilters,
}: {
  hasActiveFilters: boolean;
  children: React.ReactNode;
  handleClearFilters: () => void;
}) {
  if (!hasActiveFilters) return null;

  return (
    <>
      {/* Mobile clear button */}
      <button
        onClick={handleClearFilters}
        className="sm:hidden mt-4 w-full text-sm text-blue-600 hover:text-blue-800 dark:text-blue-400 dark:hover:text-blue-300 font-medium py-2 border-t border-gray-200"
      >
        Clear all filters
      </button>

      <div className="flex justify-between items-center mt-4 ">
        <div className="flex flex-wrap gap-2">{children}</div>
        <button
          onClick={handleClearFilters}
          className="hidden sm:block text-sm text-blue-600 hover:text-blue-800 dark:text-blue-400 dark:hover:text-blue-300 font-medium"
        >
          Clear all filters
        </button>
      </div>
    </>
  );
}
